import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from "react";
import { RecurringDonation } from "../../../../shared/components/Widget/types/Enums";
export interface FormData {
  amount: number | null;
  message: string;
  messageSenderName: string;
  showName: boolean;
  email: string;
  ssn: string;
  taxDeduction: boolean;
  newsletter: boolean;
  paymentMethod: PaymentMethodString;
  privacyPolicyAccepted: boolean;
  recurring: RecurringDonation;
}
export type PaymentMethodString = "bank" | "vipps" | "quickpay_card" | "quickpay_mobilepay" | "dkbank";
export function useFundraiserForm(paymentMethods, taxDeductionMinAmount) {
  const $ = _c(10);
  let t0;
  if ($[0] !== paymentMethods[0]) {
    t0 = {
      amount: null,
      message: "",
      messageSenderName: "",
      showName: false,
      email: "",
      ssn: "",
      taxDeduction: false,
      newsletter: false,
      paymentMethod: paymentMethods[0],
      privacyPolicyAccepted: false,
      recurring: RecurringDonation.NON_RECURRING
    };
    $[0] = paymentMethods[0];
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [formData, setFormData] = useState(t0);
  let t1;
  if ($[2] !== formData) {
    t1 = e => {
      const {
        name,
        value,
        type
      } = e.target;
      const checked = (e.target as HTMLInputElement).checked;
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value
      });
    };
    $[2] = formData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleInputChange = t1;
  let t2;
  if ($[4] !== taxDeductionMinAmount) {
    t2 = (field, value_0) => {
      setFormData(prev => {
        const next = {
          ...prev,
          [field]: value_0
        };
        if (field === "amount" && value_0 !== prev.amount && typeof taxDeductionMinAmount === "number") {
          next.taxDeduction = !!next.amount && next.amount >= taxDeductionMinAmount;
        }
        return next;
      });
    };
    $[4] = taxDeductionMinAmount;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const updateField = t2;
  let t3;
  if ($[6] !== formData || $[7] !== handleInputChange || $[8] !== updateField) {
    t3 = {
      formData,
      setFormData,
      handleInputChange,
      updateField
    };
    $[6] = formData;
    $[7] = handleInputChange;
    $[8] = updateField;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}